import React, { useState } from 'react';
import { Dialog, Tab, Tabs, } from '@mui/material';
import CustomDialogTitle from '../../customComponents/CustomDialogTitle';
import PaymentReport from './PaymentReport';
import DebtorClients from './DebtorClients';
import AppointmentReport from './AppointmentReport';
import ReferralClients from './ReferralClients';
import PaymentsByLoyalty from './PaymentsByLoyalty';

const ReportDialog: React.FC<{
    open: boolean;
    close: () => void;
}> = ({ open, close }) => {

    const [loading, setLoading] = useState(false);

    const [tabId, setTabId] = React.useState<
        'Payment Report' |
        'Payments By Loyalty' |
        'Appointment Report' |
        'Referral Clients' |
        'Debtor Clients'
    >('Payment Report');

    const handleChange = (event: React.SyntheticEvent, newValue:
        'Payment Report' |
        'Payments By Loyalty' |
        'Appointment Report' |
        'Referral Clients' |
        'Debtor Clients'
    ) => {
        setTabId(newValue);
    };

    return (
        <Dialog
            open={open}
            onClose={() => close()}
            fullWidth
            fullScreen
        >
            <CustomDialogTitle handleClose={close} title='Report' loading={loading} />
            <Tabs value={tabId} variant="scrollable" onChange={handleChange}>
                <Tab sx={{ fontSize: '0.9rem', textTransform: 'none' }} label="Appointments" value='Appointment Report' />
                <Tab sx={{ fontSize: '0.9rem', textTransform: 'none' }} label="Payments" value='Payment Report' />
                <Tab sx={{ fontSize: '0.9rem', textTransform: 'none' }} label="Payments By Loyalty" value='Payments By Loyalty' />
                <Tab sx={{ fontSize: '0.9rem', textTransform: 'none' }} label="Referral Clients" value='Referral Clients' />
                <Tab sx={{ fontSize: '0.9rem', textTransform: 'none' }} label="Debtor Clients" value='Debtor Clients' />
            </Tabs>
            {tabId === 'Payment Report' && <PaymentReport loading={loading} setLoading={setLoading} />}
            {tabId === 'Debtor Clients' && <DebtorClients loading={loading} setLoading={setLoading} />}
            {tabId === 'Appointment Report' && <AppointmentReport loading={loading} setLoading={setLoading} />}
            {tabId === 'Referral Clients' && <ReferralClients loading={loading} setLoading={setLoading} />}
            {tabId === 'Payments By Loyalty' && <PaymentsByLoyalty loading={loading} setLoading={setLoading} />}
        </Dialog>
    );
};

export default ReportDialog;

export const DownloadExcel = async (fileName: string, data: any) => {

    const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};